import { useDataChange } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props) {
  let change = useDataChange({
    context: 'selected',
    path: 'unread_count',
    viewPath: props.viewPath,
  })
  return async function onChange(value) {
    change(value?.aggregate?.count || 0)
  }
}
